import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledSectionTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  position: relative;

  h2 {
    margin-top: 0;
    color: ${colors.darkBlue};
    font-size: 16px;
    line-height: 10px;
    letter-spacing: -0.22px;
    text-wrap: nowrap;
    font-weight: 400;
  }

  .download-button-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin-right: 9px;
    margin-bottom: 10px;

    .download-button {
      border-radius: 50%;
      min-width: 28px;
      min-height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 2px 3.9px 0px #1222433b;
      cursor: pointer;

      &:hover {
        background-color: ${colors.lightBlueGrayAlpha};
      }

      img {
        width: 16px;
        height: 16px;
      }
    }
  }
`;

export const StyledSeparatorLine = styled.div`
  width: 100%;
  height: 0.5px;
  background-color: ${colors.lightBlueGray};
  margin-right: 25px;
`;
